var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basko-box-timeslot-container"},[_c('TimeslotSelector',{attrs:{"addressId":_vm.addressId,"isNotPopup":true},on:{"timeslotSelected":_vm.timeslotSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }